import type { JSX } from 'react'
// TODO: Replace with a Popcorn icon once the Ban icon is added to the design
// system. Icons are sourced from Figma and generated via `rushx icons:generate`
// in `domains/popcorn/` — coordinate with design to get it added there first.

type BanIconProps = {
  size?: number
}

export function BanIcon({ size = 24 }: BanIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size}
      height={size}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="m4.9 4.9 14.2 14.2" />
    </svg>
  )
}
